import { UserDetail } from 'model/business-base';

export abstract class GeneralIdentityApi {
  abstract getSessionIdentity(): Promise<SessionIdentity>;
}

export interface SessionIdentity {
  user: UserDetail;
  roles: SystemRoles;
}

export interface SystemRoles {
  isAdmin: boolean;
  isApprover: boolean;
  isDelegate: boolean;
  isDeviationsTeamMember: boolean;
  isDeviationsAviationTeamMember: boolean;
  isDeviationsRICTeamMember: boolean;
}
